export enum HcoOverviewContentTab {
  GENERAL_OVERVIEW = 'general-overview',
  SNAPSHOT = '360-snapshot',
}

export const HCO_OVERVIEW_CONTENT_TAB_PARAM = 'overviewTab';

type HcoOverviewContentTabLabel =
  | 'main.hcoOverview.overviewTabs.generalOverview'
  | 'main.hcoOverview.overviewTabs.snapshot';

interface HcoOverviewContentTabDefinition {
  label: HcoOverviewContentTabLabel;
  id: HcoOverviewContentTab;
}

export const HCO_OVERVIEW_CONTENT_TABS = [
  {
    label: 'main.hcoOverview.overviewTabs.generalOverview',
    id: HcoOverviewContentTab.GENERAL_OVERVIEW,
  },
  {
    label: 'main.hcoOverview.overviewTabs.snapshot',
    id: HcoOverviewContentTab.SNAPSHOT,
  },
] satisfies readonly HcoOverviewContentTabDefinition[];
